import React from "react";
import { parseLocalizedNumber } from "../../../services/functions";


const RemainingWS = ({remain}) => {
  let printRemain =parseLocalizedNumber(remain);
  return (
    <div className="d-flex flex-row bd-highlight">
      {printRemain < 0 ? (
          <div className="p-2 bd-highlight" style={{ fontSize: "13px" }}>
            <span>به تعویق افتاده</span>
          </div>
      ):(
        <>
          <div className="p-2 bd-highlight" style={{ fontSize: "13px" }}>
            {remain} km
          </div>
          <div className="p-2 bd-highlight" style={{ fontSize: "14px" }}>
            مانده
          </div>
        </>
      )}
    </div>
  );
};

export default RemainingWS;
